(function () {
  'use strict';

  var modal;
  var previousFocus;
  var previousBodyOverflow;
  var contactPath = '/faq/contact-form';

  function isContactLink(link) {
    if (!link || !link.href) return false;

    try {
      var url = new URL(link.href, window.location.origin);
      return url.origin === window.location.origin && url.pathname.replace(/\/+$/, '') === contactPath;
    } catch (error) {
      return false;
    }
  }

  function openModal() {
    if (!modal) return;

    previousFocus = document.activeElement;
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');

    var typeform = modal.querySelector('[data-quick-enquiry-typeform]');
    if (typeform && !typeform.getAttribute('src')) {
      typeform.setAttribute('src', typeform.getAttribute('data-src'));
    }

    window.setTimeout(function () {
      var closeButton = modal.querySelector('[data-quick-enquiry-close]');
      if (closeButton) closeButton.focus();
    }, 0);
  }

  function closeModal() {
    if (!modal || modal.classList.contains('hidden')) return;

    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousBodyOverflow || '';

    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }

  document.addEventListener('DOMContentLoaded', function () {
    modal = document.getElementById('quick-enquiry-modal');
    if (!modal) return;

    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a') : null;
      if (isContactLink(link)) {
        event.preventDefault();
        openModal();
        return;
      }

      if (event.target.closest && event.target.closest('[data-quick-enquiry-close]')) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    if (window.location.pathname.replace(/\/+$/, '') === contactPath) openModal();
  });
})();
